import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import ReactApexChart from "react-apexcharts";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { fetchAllattendanceReport, fetchAllattendanceReportcount, fetchAllattendanceReportDetails, fetchEmployeeTime } from "../../../core/data/redux/reports/attendance_report/attendacnereport.Action";
import { useSelector, useDispatch } from "react-redux";
import { AppDispatch } from "../../../core/data/redux/store";
import { Select } from "antd";
import dayjs from "dayjs";
import { Card, Row, Col } from "antd";
import { fetchAllDepartments } from "../../../core/data/redux/department/departmentAction";
import { fetchAllProjects } from "../../../core/data/redux/projects/project/projectAction";
import { exportToCSV, exportToExcel, exportToPDF } from "../../../core/common/GlobalFunctions/exportTableData";

interface AttendanceRecord {
  employee_id: number;
  name: string;
  department: string;
  project: string;
  punch_dates: string;
  leave_dates: string[];
  holidays?: string[];
}


interface Day {
  label: number;
  date: string;
  dayName: string;
}

interface CustomAttendanceTableProps {
  attendancelist: AttendanceRecord[];
  selectedMonth: string;
  selectedDept?: string;
  selectedProject?: string;
}
interface AttendanceReportProps {
  dept?: string;
  project?: string;
  month?: string;
  yearFilter?: string;
   showOnlyTable?: boolean;
}

const AttendanceReport: React.FC<AttendanceReportProps> = ({ dept, project, month, yearFilter,showOnlyTable }) => {
  const [attendanceDetails, setattendanceDetails] = useState<any>(null);
  const { departments } = useSelector((state: any) => state.department);
  const [selectedDept, setSelectedDept] = useState<string | undefined>(dept);
  const [selectedProject, setSelectedProject] = useState<string | undefined>(project);
  const [selectedMonth, setSelectedMonth] = useState<string>(month || dayjs().format("YYYY-MM"));
  const [selectedYear, setSelectedYear] = useState<string>(yearFilter || dayjs().year().toString());
  const [monthlyDetails, setmonthlyDetails] = useState<any>(null);
  const { projectsData } = useSelector((state: any) => state.project.projects);
  const [attendancelist, setattendacnelist] = useState<any>(null);
  const [employees, setEmployees] = useState<any[]>([]);
  const dispatch = useDispatch<AppDispatch>();


  useEffect(() => {
    if (dept) setSelectedDept(dept);
    if (project) setSelectedProject(project);
    if (month) setSelectedMonth(`${selectedYear}-${month.padStart(2, "0")}`);
    if (yearFilter) setSelectedYear(yearFilter);
  }, [dept, project, month, yearFilter, selectedYear]);




  useEffect(() => {
    dispatch(fetchAllattendanceReport()).then((res) => {
      setattendacnelist(res.payload.data);
    });
    dispatch(fetchAllProjects());
    dispatch(fetchAllDepartments());
  }, []);

  const data = attendancelist ? attendancelist : [];

  function transformAttendanceForExport(attendancelist: any[], selectedMonth: string) {
    const totalDays = dayjs(selectedMonth).daysInMonth();

    const exportData = attendancelist.map((emp) => {
      const row: any = {
        Employee: emp.name || "N/A",
      };

      // Initialize day columns
      for (let i = 1; i <= totalDays; i++) {
        row[i] = "";
      }

      const statusMap: Record<string, string> = {};

      // Attendance Status Mapping
      if (emp.attendance_status) {
        emp.attendance_status.split(",").forEach((entry: string) => {
          const [date, status] = entry.split(":").map((s) => s.trim());
          if (date && status) statusMap[date] = status.toLowerCase();
        });
      }

      // Leave Mapping
      if (emp.leave_from_dates && emp.leave_to_dates) {
        const fromDates = emp.leave_from_dates.split(",");
        const toDates = emp.leave_to_dates.split(",");

        fromDates.forEach((from: any, idx: number) => {
          const start = dayjs(from);
          const end = dayjs(toDates[idx]);
          for (let j = 0; j <= end.diff(start, "day"); j++) {
            const d = start.add(j, "day").format("YYYY-MM-DD");
            statusMap[d] = "leave";
          }
        });
      }

      // Fill each day
      for (let i = 1; i <= totalDays; i++) {
        const dateStr = dayjs(`${selectedMonth}-${i}`).format("YYYY-MM-DD");
        const st = statusMap[dateStr];

        row[i] =
          st === "present" ? "P" :
            st === "absent" ? "A" :
              st === "leave" ? "L" :
                st === "holiday" ? "H" :
                  st === "weekoff" ? "W" :
                    st === "half_day" ? "½" : "";
      }

      return row;
    });

    // 🔥 Force Employee column first (prevents XLSX from reordering)
    const columnOrder = ["Employee", ...Array.from({ length: totalDays }, (_, i) => (i + 1).toString())];

    const arrangedData = exportData.map((row: any) => {
      const orderedRow: any = {};
      columnOrder.forEach(col => {
        orderedRow[col] = row[col] ?? "";
      });
      return orderedRow;
    });

    return arrangedData; // ✅ This is final Excel-ready data
  }

  useEffect(() => {
    if (selectedYear) {
      dispatch(fetchAllattendanceReportcount(selectedYear))
        .then((res: any) => {
          const data = res.payload.data;
          setmonthlyDetails(data);
        })
        .catch((err: any) => {
          console.error("Failed to fetch payslip data:", err);
        });

      dispatch(fetchAllattendanceReportDetails(selectedYear)).then((res) => {
        setattendanceDetails(res.payload.data);
      });
    }
  }, [selectedYear]);

  const handleYearSelect = (year: any) => {
    setSelectedYear(year);
  };



  const data2 = transformAttendanceForExport(data, selectedMonth)




  const year = Number(selectedYear);  // Dynamically update months based on selected year

  const monthsOfYear = Array.from({ length: 5 }, (_, yearIndex) => {
    const year = dayjs().subtract(yearIndex, "year").year();
  
    return Array.from({ length: 12 }, (_, monthIndex) => {
      const date = dayjs().year(year).month(monthIndex);
      return {
        label: date.format("MMM YYYY"),
        value: date.format("YYYY-MM"),
      };
    });
  })
    .flat()
    .sort((a, b) => dayjs(b.value).unix() - dayjs(a.value).unix());

    
  const { Option } = Select;

  const [daysInMonth, setDaysInMonth] = useState<
    { label: number; date: string }[]
  >([]);

  useEffect(() => {
    const totalDays = dayjs(selectedMonth).daysInMonth();
    const newDays = Array.from({ length: totalDays }, (_, i) => {
      const date = dayjs(`${selectedMonth}-${i + 1}`).format("YYYY-MM-DD");
      return { label: i + 1, date };
    });
    setDaysInMonth(newDays);
  }, [selectedMonth]);

  useEffect(() => {
    if (attendancelist && attendancelist.length > 0) {
      const formattedEmployees = attendancelist.map((item: any) => ({
        id: item.employee_id,
        name: item.name,
        department: item.department || "N/A",
        project: item.project || "N/A",
        team: "Not Assigned",
      }));

      setEmployees(formattedEmployees);
    }
  }, [attendancelist]);


  function getWorkingDaysInYear(year: any, totalHolidays: number = 0): number {
    let totalDays = 0;
    let weekends = 0;

    const start = new Date(year, 0, 1);
    const end = new Date(year, 11, 31);

    for (
      let date = new Date(start);
      date <= end;
      date.setDate(date.getDate() + 1)
    ) {
      const dayOfWeek = date.getDay();
      totalDays++;

      if (dayOfWeek === 0 || dayOfWeek === 6) {
        weekends++;
      }
    }

    const workingDays = totalDays - weekends - totalHolidays;
    return workingDays;
  }

  const tholiday =
    attendanceDetails && attendanceDetails.length > 0
      ? attendanceDetails[0].Holidays
      : 0;
  const totalworkingdays = getWorkingDaysInYear(selectedYear, tholiday);

  const CustomAttendanceTable: React.FC<CustomAttendanceTableProps> = ({
    attendancelist,
    selectedMonth,
    selectedDept,
    selectedProject,
  }) => {
    const [daysInMonth, setDaysInMonth] = useState<Day[]>([]);
    const [selectedPunchDetails, setSelectedPunchDetails] = useState<{
      employeeId: number;
      date: string;
      name: string;
    } | null>(null);

    const [getEmployeetime, setEmployeetime] = useState<any[]>([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    useEffect(() => {
      if (!selectedMonth) return;

      const totalDays = dayjs(selectedMonth).daysInMonth();
      const newDays: Day[] = Array.from({ length: totalDays }, (_, i) => {
        const date = dayjs(`${selectedMonth}-${i + 1}`).format("YYYY-MM-DD");
        const dayLabel = dayjs(date).format("ddd");
        return {
          label: i + 1,
          date,
          dayName: dayLabel,
        };
      });
      setDaysInMonth(newDays);
    }, [selectedMonth]);

    useEffect(() => {
      if (selectedPunchDetails?.employeeId && selectedPunchDetails?.date) {
        dispatch(
          fetchEmployeeTime({
            employeeId: selectedPunchDetails.employeeId,
            date: selectedPunchDetails.date,
          })
        ).then((res) => {
          if (res.payload?.data) {
            setEmployeetime(res.payload.data);
          } else {
            setEmployeetime([]);
          }
        });
      }
    }, [selectedPunchDetails, isModalOpen]);

    const formattedData: any[] = useMemo(() => {
      return (attendancelist || []).map((emp: any) => {
        const statusMap: Record<string, string> = {};
        if (emp.attendance_status) {
          emp.attendance_status.split(",").forEach((entry: string) => {
            const [date, status] = entry.split(":").map((s) => s.trim());
            if (date && status) {
              statusMap[date] = status.toLowerCase();
            }
          });
        }

        const leaveDates: string[] = [];
        if (emp.leave_from_dates && emp.leave_to_dates) {
          const from = dayjs(emp.leave_from_dates);
          const to = dayjs(emp.leave_to_dates);
          const diff = to.diff(from, "day");
          for (let j = 0; j <= diff; j++) {
            leaveDates.push(from.add(j, "day").format("YYYY-MM-DD"));
          }
        }

        return {
          ...emp,
          statusMap,
          leave_dates: leaveDates,
        };
      });
    }, [attendancelist]);

    const filteredData = useMemo(() => {
      return formattedData.filter((emp) => {
        const deptMatch = selectedDept ? emp.department === selectedDept : true;

        const projMatch = selectedProject
          ? emp.project?.split(",").map((p: any) => p.trim()).includes(selectedProject)
          : true;

        return deptMatch && projMatch;
      });
    }, [formattedData, selectedDept, selectedProject]);

    // ✅ Paginated data
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);
    const paginatedData = filteredData.slice(
      (currentPage - 1) * rowsPerPage,
      currentPage * rowsPerPage
    );

    // ✅ Stats component
    const Stat = ({
      label,
      value,
      color,
    }: {
      label: string;
      value: string;
      color: string;
    }) => (
      <div style={{ margin: "6px 12px" }}>
        <div style={{ color }}>{label}</div>
        <div style={{ fontWeight: "bold" }}>{value}</div>
      </div>
    );

    const convertToMinutes = (time: string = "0") => {
      if (!time) return 0;
      const regex = /(?:(\d+)h)?\s*(?:(\d+)m)?\s*(?:(\d+)s)?/;
      const match = time.match(regex);
      if (!match) return 0;

      const [, h, m, s] = match.map(Number);
      return (h || 0) * 60 + (m || 0) + Math.floor((s || 0) / 60);
    };

    const productiveTime = convertToMinutes(getEmployeetime?.[0]?.ProductiveTime || "0");
    const breakTime = convertToMinutes(getEmployeetime?.[0]?.BreakTime || "0");
    const totalWorkingTime = convertToMinutes(getEmployeetime?.[0]?.TotalWorkingHours || "0");

    const total = totalWorkingTime || 1;
    const productivePercent = (productiveTime / total) * 100;
    const breakPercent = (breakTime / total) * 100;
    const overtimePercent = 100 - (productivePercent + breakPercent);

    return (
      <>
        {/* Table */}
        <div style={{ overflowX: "auto", paddingBottom: 20 }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "100%",
              minWidth: "700px",
            }}
          >
            <thead>
              <tr>
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 2,
                    background: "#f7f7f7",
                    border: "1px solid #ccc",
                    padding: "8px",
                    minWidth: 150,
                  }}
                >
                  Day
                </th>
                {daysInMonth.map((day) => (
                  <th
                    key={`dayname-${day.date}`}
                    style={{
                      border: "1px solid #ccc",
                      padding: "6px",
                      minWidth: 40,
                      textAlign: "center",
                      backgroundColor: "#eef",
                      fontSize: 12,
                    }}
                  >
                    {day.dayName}
                  </th>
                ))}
              </tr>
              <tr>
                <th
                  style={{
                    position: "sticky",
                    left: 0,
                    zIndex: 1,
                    background: "#f0f0f0",
                    border: "1px solid #ccc",
                    padding: "8px",
                    minWidth: 150,
                  }}
                >
                  Employee
                </th>
                {daysInMonth.map((day) => (
                  <th
                    key={`daynum-${day.date}`}
                    style={{
                      border: "1px solid #ccc",
                      padding: "4px",
                      textAlign: "center",
                    }}
                  >
                    {day.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((emp) => (
                <tr key={emp.employee_id}>
                  <td
                    style={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "#fff",
                      border: "1px solid #ccc",
                      padding: "8px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {emp.name}
                  </td>
                  {daysInMonth.map((day) => {
                    const status = emp.statusMap[day.date];

                    let bgColor = "transparent";
                    let initial = "";

                    if (status === "present") {
                      bgColor = "#66ccff";
                      initial = "P";
                    } else if (status === "absent") {
                      bgColor = "#ff6666";
                      initial = "A";
                    } else if (status === "leave") {
                      bgColor = "#fff176";
                      initial = "L";
                    } else if (status === "holiday") {
                      bgColor = "#c5e1a5";
                      initial = "H";
                    } else if (status === "weekoff") {
                      bgColor = "#d3d3d3";
                      initial = "W";
                    } else if (status === "half_day") {
                      bgColor = "#ffb74d";
                      initial = "½";
                    }

                    const handleClick = () => {
                      if (status === "present") {
                        setSelectedPunchDetails({
                          employeeId: emp.employee_id,
                          date: day.date,
                          name: emp.name,
                        });
                        setIsModalOpen(true);
                      }
                    };

                    return (
                      <td
                        key={`${emp.employee_id}-${day.date}`}
                        style={{
                          border: "1px solid #ccc",
                          padding: "4px",
                          textAlign: "center",
                          cursor: status === "present" ? "pointer" : "default",
                        }}
                        onClick={handleClick}
                      >
                        <div
                          style={{
                            width: 20,
                            height: 20,
                            backgroundColor: bgColor,
                            border: "1px solid #ccc",
                            borderRadius: 2,
                            margin: "auto",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: 12,
                            fontWeight: "bold",
                            color: "#000",
                          }}
                        >
                          {initial}
                        </div>
                      </td>
                    );
                  })}
                </tr>
              ))}
              {paginatedData.length === 0 && (
                <tr>
                  <td
                    colSpan={daysInMonth.length + 1}
                    style={{ padding: "12px", textAlign: "center" }}
                  >
                    No data found for selected filters
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* ✅ Pagination Controls */}
        {totalPages > 1 && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 16,
              gap: 8,
            }}
          >
            <button
              onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        )}
      </>
    );
  };

  useEffect(() => {
    const presentPerMonth = new Array(12).fill(0);
    const absentPerMonth = new Array(12).fill(0);

    if (monthlyDetails && monthlyDetails.length > 0) {
      monthlyDetails.forEach(
        ({ Month, EmployeesPunched, TotalEmployees }: any) => {
          const monthIndex = Month - 1;
          presentPerMonth[monthIndex] = EmployeesPunched;
          absentPerMonth[monthIndex] = Math.max(TotalEmployees - EmployeesPunched, 0);
        }
      );
    }

    setattendancechart((prev: any) => ({
      ...prev,
      series: [
        {
          ...prev.series[0],
          data: presentPerMonth,
        },
        {
          ...prev.series[1],
          data: absentPerMonth,
        },
      ],
    }));
  }, [monthlyDetails]);

  const [attendancechart, setattendancechart] = useState<any>({
    series: [
      {
        name: "Present",
        data: new Array(12).fill(0),
      },
      {
        name: "Absent",
        data: new Array(12).fill(0),
      },
    ],
    chart: {
      height: 200,
      type: "line",
      zoom: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
    },
    grid: {
      row: {
        colors: ["#f3f3f3", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
    },
    yaxis: {
      labels: {
        offsetX: -15,
      },
    },
    colors: ["#28a745", "#ff69b4"],
  });

  const formattedData = (attendancelist || []).map((item: any) => ({
    key: item.employee_id,
    id: item.employee_id,
    name: item.name,
    department: item.department,
    project: item.project,
    punch_dates: item.punch_dates ? item.punch_dates.split(",") : [],
  }));

  const [filters, setFilters] = useState<any>({
    department: null,
    project: null,
    month: null, // format: "2025-05"
  });

  const filteredDatas = formattedData.filter((item: any) => {
    const matchesDepartment =
      !filters.department || item.department === filters.department;
    const matchesProject = !filters.project || item.project === filters.project;
    const matchesMonth =
      !filters.month ||
      item.punch_dates.some((date: any) => date.startsWith(filters.month));

    return matchesDepartment && matchesProject && matchesMonth;
  });


    if (showOnlyTable) {
  return (
<>
 <div className="card">
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Attendance Report</span>
                  <div style={{ display: "flex", gap: 16 }}>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: "#66ccff", // Present
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          display: "inline-block",
                        }}
                      />
                      <span>Present</span>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: "#d3d3d3",
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          display: "inline-block",
                        }}
                      />
                      <span>Weekly Off</span>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: "#ffd966", // Half Day or Late
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          display: "inline-block",
                        }}
                      />
                      <span>Leave</span>
                    </div>
                  </div>
                </div>
              }
            >
              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col>
                  <Select
                    placeholder="Filter by Department"
                    allowClear
                    value={selectedDept}
                    onChange={setSelectedDept}
                    style={{ width: 200 }}
                  >
                    {departments.map((dept: any) => (
                      <Option key={dept.Id} value={dept.Name}>
                        {dept.Name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Select
                    placeholder="Filter by Project"
                    allowClear
                    value={selectedProject}
                    onChange={setSelectedProject}
                    style={{ width: 200 }}
                  >
                    {projectsData.map((proj: any) => (
                      <Option key={proj.project_id} value={proj.project_name}>
                        {proj.project_name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Select
                    placeholder="Select Month"
                    value={selectedMonth}
                    onChange={setSelectedMonth}
                    style={{ width: 180 }}
                  >
                    {monthsOfYear.map((month) => (
                      <Option key={month.value} value={month.value}>
                        {month.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>

              <CustomAttendanceTable
                attendancelist={attendancelist}
                selectedMonth={selectedMonth}
                selectedDept={selectedDept}
                selectedProject={selectedProject}
              />
            </Card>
          </div>
</>
  );
}

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Attendance Report</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.adminDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">HR</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Attendance Report
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="mb-2">
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    <i className="ti ti-file-export me-1" />
                    Export
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <button
                        onClick={() => exportToCSV(data2, "Attendance_Report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-pdf me-1" />
                        Export as CSV
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToExcel(data2, "Attendance_Report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as Excel{" "}
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => exportToPDF(data2, "Attendance_Report")}
                        className="dropdown-item rounded-1"
                      >
                        <i className="ti ti-file-type-xls me-1" />
                        Export as PDF{" "}
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="row">
            <div className="col-xl-6 d-flex">
              <div className="row flex-fill">
                {/* Total Companies */}
                {/* <div className="col-lg-6 col-md-6 d-flex"> */}
                {/* <div className="card flex-fill"> */}
                {/* <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-primary" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Working Days
                          </p>
                          <h4>{totalworkingdays}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={totalworkingdays}
                          aria-valuemin={0}
                          aria-valuemax={365}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div> */}
                {/* </div> */}
                {/* </div> */}
                {/* /Total Companies */}
                {/* Total Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-info" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Leave Taken
                          </p>
                          <h4>{attendanceDetails?.[0].ApprovedLeaves}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={attendanceDetails?.[0].ApprovedLeaves}
                          aria-valuemin={0}
                          aria-valuemax={365}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Total Companies */}
                {/* Inactive Companies */}
                <div className="col-lg-6 col-md-6 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-pink" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Holidays
                          </p>
                          <h4>{attendanceDetails?.[0].Holidays}</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={attendanceDetails?.[0].Holidays}
                          aria-valuemin={0}
                          aria-valuemax={365}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Inactive Companies */}
                {/* Company Location */}
                <div className="col-lg-6 col-md-6 d-flex">
                  {/* <div className="card flex-fill">
                    <div className="card-body">
                      <div className="d-flex align-items-center overflow-hidden mb-2">
                        <div className="attendence-icon">
                          <span>
                            <i className="ti ti-calendar text-warning" />
                          </span>
                        </div>
                        <div className="ms-2 overflow-hidden">
                          <p className="fs-12 fw-normal mb-1 text-truncate">
                            Total Halfdays
                          </p>
                          <h4>5</h4>
                        </div>
                      </div>
                      <div className="attendance-report-bar mb-2">
                        <div
                          className="progress"
                          role="progressbar"
                          aria-label="Success example"
                          aria-valuenow={25}
                          aria-valuemin={0}
                          aria-valuemax={100}
                          style={{ height: 5 }}
                        >
                          <div
                            className="progress-bar bg-success"
                            style={{ width: "85%" }}
                          />
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
                {/* /Company Location */}
              </div>
            </div>
            <div className="col-xl-6">
              <div className="card">
                <div className="card-header border-0 pb-0">
                  <div className="d-flex flex-wrap justify-content-between align-items-center">
                    <div className="d-flex align-items-center ">
                      <span className="me-2">
                        <i className="ti ti-chart-line text-danger" />
                      </span>
                      <h5>Attendance</h5>
                    </div>
                    <div className="dropdown">
                      <Link
                        to="#"
                        className="dropdown-toggle btn btn-sm fs-12 btn-white d-inline-flex align-items-center"
                        data-bs-toggle="dropdown"
                      >
                        {selectedYear}
                      </Link>
                      <ul className="dropdown-menu  dropdown-menu-end p-2">
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2025")}
                          >
                            2025
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2024")}
                          >
                            2024
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            className="dropdown-item rounded-1"
                            onClick={() => handleYearSelect("2023")}
                          >
                            2023
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="card-body py-0 px-2">
                  <ReactApexChart
                    id="payslip-chart"
                    options={attendancechart}
                    series={attendancechart.series}
                    type="line"
                    height={200}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="card">
            <Card
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Attendance Report</span>
                  <div style={{ display: "flex", gap: 16 }}>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: "#66ccff", // Present
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          display: "inline-block",
                        }}
                      />
                      <span>Present</span>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: "#d3d3d3",
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          display: "inline-block",
                        }}
                      />
                      <span>Weekly Off</span>
                    </div>
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 4 }}
                    >
                      <span
                        style={{
                          width: 16,
                          height: 16,
                          backgroundColor: "#ffd966", // Half Day or Late
                          border: "1px solid #ccc",
                          borderRadius: 2,
                          display: "inline-block",
                        }}
                      />
                      <span>Leave</span>
                    </div>
                  </div>
                </div>
              }
            >
              <Row gutter={16} style={{ marginBottom: 16 }}>
                <Col>
                  <Select
                    placeholder="Filter by Department"
                    allowClear
                    value={selectedDept}
                    onChange={setSelectedDept}
                    style={{ width: 200 }}
                  >
                    {departments.map((dept: any) => (
                      <Option key={dept.Id} value={dept.Name}>
                        {dept.Name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Select
                    placeholder="Filter by Project"
                    allowClear
                    value={selectedProject}
                    onChange={setSelectedProject}
                    style={{ width: 200 }}
                  >
                    {projectsData.map((proj: any) => (
                      <Option key={proj.project_id} value={proj.project_name}>
                        {proj.project_name}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col>
                  <Select
                    placeholder="Select Month"
                    value={selectedMonth}
                    onChange={setSelectedMonth}
                    style={{ width: 180 }}
                  >
                    {monthsOfYear.map((month) => (
                      <Option key={month.value} value={month.value}>
                        {month.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>

              <CustomAttendanceTable
                attendancelist={attendancelist}
                selectedMonth={selectedMonth}
                selectedDept={selectedDept}
                selectedProject={selectedProject}
              />
            </Card>
          </div>
        </div>
        <div className="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3">
          <p className="mb-0">2024 - 2025© hrmtree.</p>
          <p>
            Developed By{" "}
            <Link to="#" className="text-primary">
              Leadchain Systems
            </Link>
          </p>
        </div>
      </div>
      {/* /Page Wrapper */}
    </>
  );
};

export default AttendanceReport;
